import UserService from '../../services/user/UserService';

export default {
    data() {
        return {
            email: null
        }
    },
    computed: {
        isDisabled() {
            return !this.email;
        }
    },
    methods: {
        async sendEmail() {
            try {
                if (!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.email)) {
                    this.$buefy.toast.open({ message: 'Debes ingresar un correo válido', type: 'is-danger' })
                    return
                }
                const response = await UserService.recoveryToken(this.email);
                this.$buefy.toast.open({ message: 'Se ha enviado un correo con los pasos a seguir para recuperar su contraseña', type: 'is-success' })
                this.$router.push('/login')
            } catch (error) {
                this.$buefy.toast.open({ message: 'Hubo un problema. Intenta mas tarde', type: 'is-danger' })
            }
        }
    }
}